/**
 * @file
 * Nav Circles script.
 */

(function navCirclesScript($, Drupal, _) {
  'use strict';

  /*
   * Set click targets.
   */
  Drupal.behaviors.navCirclesTarget = {
    attach: function (context) {
      var $clickZone = $('.js-nav-circle--click-zone', context);

      $clickZone.each(function () {
        var $target = $('a', $(this)).first();
        $target.bigTarget({
          clickZone: '.js-nav-circle--click-zone',
          clickZoneClass: 'js-nav-circle',
          anchorClass: 'js-nav-circle__target'
        });
      });
    }
  };

  /*
   * Set text sizes.
   */
  Drupal.behaviors.navCirclesTextSize = {
    attach: function (context) {
      var $navCircles = $('.nav-circle', context);
      // Map a utility class to set font-size/line-height
      // based on a current line-height.
      var sizeMap = {
        24: 'u-text--18-22',
        20: 'u-text--14-16',
        16: 'u-text--12-14'
      };

      $navCircles.each(function () {
        var $t = $(this);
        var $text = $('a', $t);
        var textHeight = $text.height();
        var lineHeight = parseInt($text.css('line-height'));
        // The height of the text divided by the current line-height
        // will tell us how many lines of text we have.
        var lineNums = textHeight / lineHeight;

        function setSize(navCircle) {
          // If text is four or more lines, bump down the
          // font-size/line-height by setting utility class.
          if (lineNums >= 4) {
            navCircle.addClass(sizeMap[lineHeight]);
          }
          // Else, remove any traces of the classes.
          else {
            for (var size in sizeMap) {
              if (size) {
                navCircle.removeClass(sizeMap[size]);
              }
            }
          }
        }

        setSize($t);

        $(window).resize(_.debounce(function () {
          // Re-evaluate some variables.
          textHeight = $text.height();
          lineHeight = parseInt($text.css('line-height'));
          lineNums = textHeight / lineHeight;

          setSize($t);
        }, 50));
      });
    }
  };
}(jQuery, Drupal, _));
